import { VL_SUPPORT_OWNERS } from '../ManageTickets/vlSupportEmail';

/** Shared ownership: nobody in particular, the whole team. */
export const TEAM_OWNER = 'Team';

/**
 * Clicking a chip in the owner picker. Team is on its own: choosing it clears the names, and choosing
 * a name turns Team off. Turning off the last name goes back to Team, so a ticket always has an owner.
 */
export function toggleOwner(current: string[], name: string): string[] {
  if (name === TEAM_OWNER) return [TEAM_OWNER];
  const people = current.filter((o) => o !== TEAM_OWNER);
  const next = people.includes(name) ? people.filter((o) => o !== name) : [...people, name];
  return next.length ? next : [TEAM_OWNER];
}

/** Everyone a ticket can be assigned to: Team, the team roster, and the logged-in person if they are not on it. */
export function ownerChoices(myInitials = ''): string[] {
  const roster: string[] = [...VL_SUPPORT_OWNERS];
  const mine = myInitials && !roster.includes(myInitials) ? [myInitials] : [];
  return [TEAM_OWNER, ...roster, ...mine];
}

/** Who is picked when a person opens a reply box: themselves if they are on the roster, otherwise Team. */
export const defaultOwners = (myInitials = ''): string[] =>
  myInitials && (VL_SUPPORT_OWNERS as readonly string[]).includes(myInitials) ? [myInitials] : [TEAM_OWNER];

/** The people in charge of a ticket row, falling back to its single older initials. */
export function ticketOwners(t: { vst_owners?: string[] | null; vst_owner_initials?: string | null }): string[] {
  if (t.vst_owners && t.vst_owners.length) return t.vst_owners;
  return t.vst_owner_initials ? [t.vst_owner_initials] : [];
}
